import { render, staticRenderFns } from "./NewPixPaymentForm.vue?vue&type=template&id=6c66da42&scoped=true"
import script from "./NewPixPaymentForm.vue?vue&type=script&lang=js"
export * from "./NewPixPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./NewPixPaymentForm.vue?vue&type=style&index=0&id=6c66da42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66da42",
  null
  
)

export default component.exports